export default __webpack_public_path__ + "static/media/floating-cogs.b13f3fb8.svg";